import {
    EditorPage,
    CorrectionsPage,
    NotesPage,
    ShufflePage,
    BrokenPartsPage,
    SamplesPage,
    SearchPage,
    SuggestionsPage,
    StylesheetPage,
    BookPartsChangesPage,
    EditorLightPage
} from './views';

const routes = [
    {
        path: '/editor/:id',
        name: 'editor',
        component: EditorPage
    },
    {
        path: '/editor/:id/corrections',
        name: 'corrections',
        component: CorrectionsPage
    },
    {
        path: '/editor/:id/notes',
        name: 'notes',
        component: NotesPage
    },
    {
        path: '/editor/:id/broken',
        name: 'broken-parts',
        component: BrokenPartsPage
    },
    {
        path: '/editor/:id/samples',
        name: 'samples',
        component: SamplesPage
    },
    {
        path: '/editor/:id/search',
        name: 'search',
        component: SearchPage
    },
    {
        path: '/editor/:id/suggestions',
        name: 'suggestions',
        component: SuggestionsPage
    },
    {
        path: '/editor/:id/shuffle',
        name: 'shuffle',
        component: ShufflePage
    },
    {
        path: '/editor/:id/stylesheet',
        name: 'stylesheet',
        component: StylesheetPage
    },
    {
        path: '/editor/:id/changes',
        name: 'bookpartschanges',
        component: BookPartsChangesPage
    },

    // embed routes
    {
        path: '/embed/light/:id',
        name: 'editor-light',
        component: EditorLightPage,
        props: {
            isEmbed: true
        },
        meta: { guest: true }
    },
    {
        path: '/embed/:id',
        name: 'embed',
        component: EditorPage,
        props: {
            isEmbed: true
        },
        meta: {
            guest: true
        }
    },
    {
        path: '/embed/:id/corrections',
        name: 'embed-corrections',
        component: CorrectionsPage,
        props: {
            isEmbed: true
        },
        meta: {
            guest: true
        }
    },
    {
        path: '/embed/:id/broken',
        name: 'embed-broken-parts',
        component: BrokenPartsPage,
        props: {
            isEmbed: true
        },
        meta: {
            guest: true
        }
    },
    {
        path: '/embed/:id/samples',
        name: 'embed-samples',
        component: SamplesPage,
        props: {
            isEmbed: true
        },
        meta: {
            guest: true
        }
    },
    {
        path: '/embed/:id/search',
        name: 'embed-search',
        component: SearchPage,
        props: {
            isEmbed: true
        },
        meta: {
            guest: true
        }
    },
    {
        path: '/embed/:id/suggestions',
        name: 'embed-suggestions',
        component: SuggestionsPage,
        props: {
            isEmbed: true
        },
        meta: {
            guest: true
        }
    },
    {
        path: '/embed/:id/shuffle',
        name: 'embed-shuffle',
        component: ShufflePage,
        props: {
            isEmbed: true
        },
        meta: {
            guest: true
        }
    },
    {
        path: '/embed/:id/stylesheet',
        name: 'embed-stylesheet',
        component: StylesheetPage,
        props: {
            isEmbed: true
        },
        meta: {
            guest: true
        }
    }
];

export default routes;
